import { makeStyles } from "@material-ui/core";

export const ReservationAssetTypesStyle = makeStyles((theme) => ({
    assetTypeName: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    }
}));